import { CLIENT_COSTS, LEGACY_CLIENT_COSTS } from "./Const";
import { getClientChargeClassType } from "./Helpers";

export const CLIENT_PRICING_EFFECTIVE_DATE = "2026-09-01";

// Use the lesson's calendar date, never today's date or the report generation date.
export function getClientLessonPricing(classType, presentCount, lessonDate) {
  const date = typeof lessonDate === "string" ? lessonDate.slice(0, 10) : "";
  const currentPricing = /^\d{4}-\d{2}-\d{2}$/.test(date) && date >= CLIENT_PRICING_EFFECTIVE_DATE;
  const chargeClassType = currentPricing ? classType : getClientChargeClassType(classType, presentCount);
  const prices = currentPricing ? CLIENT_COSTS : LEGACY_CLIENT_COSTS;
  return { classType: chargeClassType, rate: prices[chargeClassType] };
}
